import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=41b4b175&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=41b4b175&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4b175",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b4b175')) {
      api.createRecord('41b4b175', component.options)
    } else {
      api.reload('41b4b175', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=41b4b175&scoped=true", function () {
      api.rerender('41b4b175', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Search.vue"
export default component.exports